/*
    ES2023 array prototype style methods
*/

export const withArray = <T = any>(array: T[], index: number, item: T): T[] => {
    return [...array.slice(0, index), item, ...array.slice(index + 1)];
};

export const toSpliced = <T = any>(array: T[], index: number, deleteCount: number, ...items: T[]): T[] => {
    return [...array.slice(0, index), ...items, ...array.slice(index + deleteCount)];
};
